import {Component, Input, OnInit} from '@angular/core';

import {GrhumService} from '../../grhum';
import {Response} from '@angular/http';
import {CandidatureFormation} from '../candidature-formation.model';
import {CONSTANTS} from '../../../cadens.constants';
import {ParametrageService} from '../../parametrage';
import {JhiLanguageService} from 'ng-jhipster';

@Component({
    selector: 'jhi-confirmation-component',
    templateUrl: './confirmation.component.html'
})
export class ConfirmationComponent implements OnInit {

    @Input() candidatureFormation: CandidatureFormation;
    parametrage: any;
    mention: string;
    parcours: string;
    niveau: string;
    discipline: string;
    currentLang: string;

    constructor(private parametrageService: ParametrageService,
                private grhumService: GrhumService,
                private jhiLanguageService: JhiLanguageService) {
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }

    ngOnInit() {
        this.parametrageService.query({ page: CONSTANTS.CONFIRMATION}).subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        if (this.candidatureFormation.mentionId) {
            this.grhumService.findComposant(this.candidatureFormation.mentionId).subscribe((res: Response) => {
                let json = res.json();
                this.mention = json.llComposant;
            });
        }
        if (this.candidatureFormation.parcoursId) {
            this.grhumService.findComposant(this.candidatureFormation.parcoursId).subscribe((res: Response) => {
                let json = res.json();
                this.parcours = json.llComposant;
            });
        }
        if (this.candidatureFormation.niveauId) {
            this.grhumService.findComposant(this.candidatureFormation.niveauId).subscribe((res: Response) => {
                let json = res.json();
                this.niveau = json.llComposant;
            });
        }
        if (this.candidatureFormation.disciplineId) {
            this.grhumService.findDiscipline(this.candidatureFormation.disciplineId).subscribe((res: Response) => {
                let json = res.json();
                this.discipline = json.llDiscipline;
            });
        }
    }

    // noinspection JSMethodCanBeStatic
    escapeParam(param: String) {
        if (param != null) {
            return (param.replace(/'/g, ' '));
        }
        return param ;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/confirmation/confirmation.component.ts